export const APPOINTMENT_STATUS = {
    REQUEST: ['requested', 'requested'],
    CANCEL: ['cancelled', 'cancelled'],
    COMPLETE: ['completed', 'completed'],
    SCHEDULE: ['scheduled', 'scheduled'],
}